var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend w-1920"},[_vm._m(0),_c('store-recommend-node')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-division"},[_c('div',{staticClass:"recommend-division-bulge"},[_c('img',{attrs:{"src":require("../../assets/store/division-bulge.png")}})])])
}]

export { render, staticRenderFns }